import { AxiosPromise } from 'axios';
import axios from 'axios';
import { IGetLanding, IGetLandings, ILandingParams } from '../models/landing.model';
import QueryString from 'qs';

const uri = '/mgmt/landing';

export const getLandings = (params: ILandingParams): AxiosPromise<IGetLandings> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}?${qsParams}`);
};

export const getLanding = (landingCode: number): AxiosPromise<IGetLanding> => {
  return axios.get(`${uri}/${landingCode}`);
};

export const createLanding = (data: FormData): AxiosPromise => {
  return axios.post(uri, data);
};

export const updateLanding = (landingCode: number, data: FormData): AxiosPromise => {
  return axios.put(`${uri}/${landingCode}`, data);
};

export const deleteLanding = (landingCode: number): AxiosPromise => {
  return axios.delete(`${uri}/${landingCode}`);
};